export default __webpack_public_path__ + "static/media/desktop_frais_carburant.0dac062e.svg";